import React from "react";
import Lottie from "react-lottie";
import Sazmandehi from "../Images/LottieJson/sazmandehi.json";

export default props => {
  return (
    <Lottie
      style={{
        height: props.size || "100%",
        width: "100%"
      }}
      options={{
        loop: true,
        autoplay: true,
        animationData: Sazmandehi,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      }}
      isClickToPauseDisabled={true}
      isStopped={false}
      isPaused={false}
    />
  );
};
